import M_TOOLKIT from '../../../../main/components/toolkit/index.js'
import { G_EVENT_CODE_MAP, G_EVENT_TYPE_MAP, G_REPORT_SOURCE_MAP } from '../../../../config/index.js'
import { M_EVENT_PARAMS } from '../common_params/index.js'
// 基础数据采集
const collectBase = (main, params, com_params) => {

    // 如果实例上存在page id则判断业务是否有传递，无传递则默认传递
    if (main.pageId && (!params.event_params || !params.event_params.flx_page)) {
        if (!params.event_params) {
            params.event_params = {}
        }

        params.event_params.flx_page = main.pageId
    }

    // 组装一层基础数据给到data层处理
    return {
        origin_params: params,
        ...com_params
    }
}

// pv数据采集
const collectPV = (main, params) => {
    // params.is_pv_report = true
    params.event_type = G_EVENT_TYPE_MAP.expose
    let event_params = M_EVENT_PARAMS({...params, event_code: G_EVENT_CODE_MAP.pageView})
    return {
        origin_params: params,
        event_params
    }
}
// leave数据采集
const collectLeave = (main, params) => {
    // params.is_leave_report = true
    params.leave_time = M_TOOLKIT.getTime()
    let event_params = M_EVENT_PARAMS({...params, event_code: G_EVENT_CODE_MAP.pageOut})
    return {
        origin_params: params,
        event_params
    }
}
// 页面停留数据采集
const collectStay = (main, params) => {
    params.enter_time = main.initTime
    params.leave_time = main.pageExitTime || M_TOOLKIT.getTime()
    params.duration = params.leave_time - params.enter_time
    let event_params = M_EVENT_PARAMS({...params, event_code: G_EVENT_CODE_MAP.pageStay})
    return {
        origin_params: params,
        event_params
    }
}
// dom节点数据采集
const collectDom = (main, params) => {
    params.event_type = G_EVENT_TYPE_MAP.click
    if (params.isTraceless) {
        params.event_pos = 'LX.REPORT.TRACELESS.CLICK'
        params.event_pos_name = '乐信无痕埋点-点击事件'
        params.report_source = G_REPORT_SOURCE_MAP.sdk
        delete params.isTraceless
    }
    let event_params = M_EVENT_PARAMS({...params, event_code: G_EVENT_CODE_MAP.elementClick})
    return {
        origin_params: params,
        event_params
    }
}

export default {
    collectBase,
    collectPV,
    collectLeave,
    collectStay,
    collectDom
}